<template>
  <div class="component gift-certificate-cart-item">
    <div class="gift">
      <dl class="details">
        <dt>{{ $t('general.label.recipient') }}:</dt>
        <dd>{{ item.giftFirstName }} {{ item.giftLastName }}</dd>
        <dt>{{ $t('form.label.guest.email') }}:</dt>
        <dd>{{ item.giftEmail }}</dd>
        <dt>{{ $t('general.label.message') }}:</dt>
        <dd>{{ item.giftMessage }}</dd>
      </dl>
      <div class="subtotal">{{ $formatter.currency(item.subTotal) }}</div>
    </div>
  </div>
</template>

<script>
// import Cart from '@/models/Cart';

export default {
  props: ['item'],

  data() {
    return {
    };
  },

  computed: {
  },

  methods: {
  }
}
</script>

<style lang="scss">
.component.gift-certificate-cart-item {
  .gift {
    .subtotal {
      @include font-h2;
      text-align: right;
    }
  }
}
</style>
